import { render, staticRenderFns } from "./UsersPermissionGroups.vue?vue&type=template&id=b5d0ee72"
import script from "./UsersPermissionGroups.vue?vue&type=script&lang=js"
export * from "./UsersPermissionGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports